import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'pricing_detail_page' */ './ProfitItemsDetailPage'
  ),
);
